import { Box, BoxProps } from '@chakra-ui/react';

export default function ContainerBox(props: BoxProps) {
  return (
    <Box
      h="100%"
      w="100%"
      bg={['none', 'white']}
      borderWidth="2px"
      borderStyle="solid"
      borderColor="podcastShade200"
      px={['15px', '40px', null, null, '60px']}
      py={['24px', '36px', null, null, '48px']}
      borderRadius="12px"
      {...props}
    />
  );
}
